// Utility: build a click-to-WhatsApp URL for a guest reservation.
// Uses the guest's phone number and a templated message including a cancel link.

const stripPhone = (p) => (p || "").replace(/[^\d+]/g, "").replace(/^\+/, "");

export function buildGuestWhatsAppUrl(reservation, siteOrigin) {
  const phone = stripPhone(reservation.phone);
  if (!phone) return null;
  const cancel = `${siteOrigin}/r/cancel/${reservation.cancel_token || ""}`;
  const status = reservation.status || "pending";
  const partyLabel = `${reservation.party_size} pax`;
  let body = "";
  if (status === "confirmed") {
    body =
      `Hello ${reservation.name}, this is The Barracks Bistro. Your table is confirmed for ` +
      `${reservation.date} at ${reservation.time} (${partyLabel}). ` +
      `We look forward to hosting you. If plans change, you can cancel here: ${cancel}`;
  } else if (status === "declined") {
    body =
      `Hello ${reservation.name}, this is The Barracks Bistro. Unfortunately we are unable to accommodate ` +
      `your booking for ${reservation.date} at ${reservation.time}. Please reach out and we will help ` +
      `find another slot.`;
  } else {
    body =
      `Hello ${reservation.name}, this is The Barracks Bistro following up on your booking request for ` +
      `${reservation.date} at ${reservation.time} (${partyLabel}). We will confirm shortly. ` +
      `You can manage or cancel this booking here: ${cancel}`;
  }
  return `https://wa.me/${phone}?text=${encodeURIComponent(body)}`;
}
